import { api } from 'utility';
import {
  getDeleteDepositWithDrawlRequestUrl,
  getDepositWithDrawlRequestUrl,
  getCreditUrl,
} from 'URLs';
// Cards
export function getWithdrawRules(params) {
  return api.get(getDepositWithDrawlRequestUrl(), { params }).then((res) => res.data);
}

export function deleteWithdrawRule(id) {
  return api.delete(getDeleteDepositWithDrawlRequestUrl(id)).then((res) => res.data);
}

export function getCredit(params) {
  return api.get(getCreditUrl(), { params }).then((res) => res.data);
}

export default {
  getWithdrawRules,
  deleteWithdrawRule,
  getCredit,
};
